(function (window) {
  'use strict';

  function groupId(line) {
    var properties = line && line.properties || {};
    return properties['_JK Prescription Group ID'] || properties['_Prescription Group ID'] || properties['Prescription Group ID'] || '';
  }

  function role(line) {
    return line && line.properties && line.properties['Purchase Type'] || '';
  }

  function linesForGroup(cart, id) {
    return (cart && cart.items || []).filter(function (line) { return groupId(line) === id; });
  }

  function removalPlan(cart, id, action) {
    var lines = linesForGroup(cart, id);
    if (action === 'remove-frame') {
      return lines.map(function (line) { return { key: line.key, quantity: 0 }; });
    }
    if (action !== 'remove-lens') throw new Error('Unknown prescription cart action.');

    var frames = lines.filter(function (line) { return role(line) === 'Prescription Frame'; });
    var lenses = lines.filter(function (line) { return role(line) === 'Prescription Lens'; });
    var extras = lines.filter(function (line) { return frames.indexOf(line) === -1 && lenses.indexOf(line) === -1; });
    var plan = frames.map(function (line) {
      return { key: line.key, quantity: Number(line.quantity) || 1, properties: { 'Purchase Type': 'Frame Only' } };
    });
    return plan.concat(lenses.concat(extras).map(function (line) { return { key: line.key, quantity: 0 }; }));
  }

  function groupedLines(cart) {
    var groups = Object.create(null);
    (cart && cart.items || []).forEach(function (line) {
      var id = groupId(line);
      if (id) (groups[id] = groups[id] || []).push(line);
    });
    return groups;
  }

  function orphanedGroupActions(cart) {
    var groups = groupedLines(cart);
    return Object.keys(groups).reduce(function (actions, id) {
      var lines = groups[id];
      var hasFrame = lines.some(function (line) { return role(line) === 'Prescription Frame'; });
      var hasLens = lines.some(function (line) { return role(line) === 'Prescription Lens'; });
      if (hasFrame && hasLens) return actions;
      actions.push({ groupId: id, action: hasFrame ? 'remove-lens' : 'remove-frame' });
      return actions;
    }, []);
  }

  window.JodyKoesPrescriptionCartLinks = {
    getGroupId: groupId,
    getRole: role,
    linesForGroup: linesForGroup,
    removalPlan: removalPlan,
    orphanedGroupActions: orphanedGroupActions
  };
})(window);
